<script setup lang="ts">
// Desligamento geral (Operações do site, ENG-915): com o site desligado no
// core, esta é a ÚNICA tela. O `app.vue` a renderiza NO LUGAR do `NuxtLayout`,
// como a parede do PWA, então não há site montado por trás — nem header, nem
// menu, nem modal. Textos fixos, do layout aprovado: trocar exige deploy.
useHead({
  title: 'ApostaTudo · Site indisponível',
  meta: [
    { name: 'robots', content: 'noindex' },
    { name: 'theme-color', content: '#020716' },
  ],
});
</script>

<template>
  <div class="shutdown">
    <main class="shutdown-main">
      <svg
        aria-label="ApostaTudo"
        class="shutdown-logo"
        fill="none"
        role="img"
        viewBox="0 0 892 120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M175.22 27.23H160.11L130.62 93.28H140.97L149.01 75.19H185.18L193.22 93.28H204.63L175.22 27.23ZM152.63 66.95L167.09 34.3L181.54 66.95H152.63Z"
          fill="#fff"
        />
        <path
          d="M269.11 32.82C265.57 29.1 260.02 27.23 252.49 27.23H212.95V93.28H223.87V69.24H252.49C260.01 69.24 265.56 67.38 269.11 63.66C272.64 59.91 274.42 54.76 274.42 48.18C274.42 41.6 272.63 36.54 269.11 32.82ZM263.4 49.82C263.4 53.02 262.42 55.61 260.43 57.62C258.45 59.63 255.36 60.64 251.14 60.64H223.87V45.29C223.87 41.64 220.9 38.68 217.26 38.68V35.77L251.14 35.83C255.41 35.83 258.53 36.87 260.47 38.89C262.42 40.94 263.39 43.58 263.39 46.85V49.82H263.4Z"
          fill="#fff"
        />
        <path
          d="M348.47 33.79C341.98 28.65 332.52 26.07 320.08 26.07C307.64 26.07 298.18 28.64 291.7 33.79C285.21 38.92 281.97 47.68 281.97 60.06C281.97 72.44 285.2 81.27 291.7 86.53C298.18 91.79 307.64 94.43 320.08 94.43C332.52 94.43 341.98 91.79 348.47 86.53C354.95 81.27 358.17 72.45 358.17 60.06C358.17 47.67 354.95 38.92 348.47 33.79ZM347.06 63.41C347.06 71.2 344.8 76.88 340.27 80.46C335.74 84.03 329 85.82 320.07 85.82C311.14 85.82 304.4 84.03 299.87 80.46C295.34 76.88 293.07 71.2 293.07 63.41V56.72C293.07 48.99 295.35 43.39 299.87 39.92C304.4 36.43 311.14 34.69 320.07 34.69C329 34.69 335.74 36.43 340.27 39.92C344.8 43.39 347.06 48.99 347.06 56.72V63.41Z"
          fill="#fff"
        />
        <path
          d="M423.08 60.29C417.58 58.1 411.57 56.69 404.99 56.09C398.41 55.49 392.38 54.74 386.89 53.84C381.42 52.95 378.67 50.1 378.67 45.32C378.67 41.3 380.39 38.47 383.84 36.86C387.28 35.23 392.29 34.41 398.87 34.41C404.62 34.41 409.26 35.16 412.8 36.65C416.33 38.15 418.39 40.95 418.99 45.03H430.18C429.55 38.34 426.6 33.49 421.34 30.54C416.05 27.57 408.58 26.08 398.88 26.08C389.18 26.08 381.42 27.65 375.95 30.77C370.5 33.89 367.75 38.78 367.75 45.4C367.75 52.75 370.51 57.47 376 59.57C381.47 61.69 387.51 63.04 394.09 63.66C400.65 64.25 406.7 65.05 412.17 66.05C417.67 67.03 420.42 70.04 420.42 75.09C420.42 78.86 418.79 81.64 415.54 83.41C412.27 85.21 407.11 86.09 400.02 86.09C392.93 86.09 388.03 85.33 384.54 83.8C381.07 82.27 378.82 79.3 377.81 74.89H366.61C367.51 81.92 370.6 86.92 375.9 89.92C381.19 92.93 389.23 94.43 400.02 94.43C410.81 94.43 418.72 92.84 423.76 89.64C428.81 86.45 431.31 81.43 431.31 74.61C431.31 67.27 428.58 62.51 423.09 60.29H423.08Z"
          fill="#fff"
        />
        <path
          d="M434.58 27.23V36.23H461.55V93.29H472.47V45.19C472.47 41.58 469.55 38.65 465.93 38.65V36.25H472.47L499.47 36.24V27.24H434.57L434.58 27.23Z"
          fill="#fff"
        />
        <path
          d="M534.23 27.23H519.12L489.62 93.28H499.97L508.01 75.19H544.21L552.25 93.28H563.64L534.25 27.23H534.23ZM511.64 66.95L526.09 34.3L540.55 66.95H511.64Z"
          fill="#fff"
        />
        <path
          d="M636.08 41.88V27.23H565.63V41.88H591.87V93.29H609.86V53.4C609.86 48.51 606.3 44.33 601.45 43.57V41.88H636.07H636.08Z"
          fill="#fff"
        />
        <path
          d="M697.93 27.23V64.86C697.93 71.23 696.44 75.47 693.45 77.58C690.44 79.69 685.9 80.74 679.84 80.74C673.78 80.74 669.23 79.69 666.21 77.58C663.17 75.47 661.67 71.23 661.67 64.86V27.23H643.66V65.52C643.66 75.8 646.77 83.22 652.94 87.79C659.14 92.34 668.11 94.62 679.84 94.62C691.57 94.62 699.77 92.34 705.55 87.79C711.33 83.22 714.22 75.8 714.22 65.52V27.23H697.93Z"
          fill="#fff"
        />
        <path
          d="M798.94 44.64C797.41 40.42 795.17 37.04 792.28 34.45C789.38 31.88 785.77 30.01 781.46 28.9C777.17 27.78 772.22 27.23 766.69 27.23H727.05V93.28H766.69C772.23 93.28 777.18 92.72 781.46 91.61C785.78 90.5 789.39 88.64 792.28 86.06C795.18 83.47 797.41 80.07 798.94 75.87C800.47 71.65 801.23 66.45 801.23 60.27C801.23 54.09 800.47 48.87 798.94 44.65V44.64ZM782.95 63.13C782.95 69.06 781.46 73.12 778.51 75.33C775.54 77.54 771.17 78.63 765.44 78.63H745.04V52.22C745.04 47.47 741.19 43.63 736.45 43.63V41.87H765.43C771.16 41.87 775.54 42.99 778.5 45.22C781.45 47.46 782.94 51.35 782.94 56.9V63.13H782.95Z"
          fill="#fff"
        />
        <path
          d="M888.78 43.69C886.97 39.35 884.32 35.86 880.84 33.2C877.35 30.56 873.05 28.67 867.92 27.56C862.78 26.44 856.91 25.87 850.35 25.87C843.79 25.87 837.83 26.43 832.69 27.56C827.55 28.67 823.23 30.55 819.76 33.2C816.27 35.86 813.63 39.34 811.82 43.69C809.99 48.05 809.08 53.4 809.08 59.78C809.08 66.16 809.99 71.85 811.82 76.34C813.63 80.8 816.28 84.39 819.76 87.11C823.23 89.82 827.55 91.76 832.69 92.89C837.82 94.04 843.71 94.62 850.35 94.62C856.99 94.62 862.78 94.04 867.92 92.89C873.05 91.77 877.35 89.83 880.84 87.11C884.33 84.4 886.97 80.8 888.78 76.34C890.61 71.86 891.51 66.35 891.51 59.78C891.51 53.21 890.61 48.04 888.78 43.69ZM873.33 63.61C873.33 70.26 871.39 74.77 867.54 77.16C863.67 79.54 857.95 80.74 850.35 80.74C842.75 80.74 837.01 79.53 833.13 77.16C829.22 74.77 827.28 70.26 827.28 63.61V56.62C827.28 50.35 829.22 45.99 833.13 43.49C837.01 41.02 842.74 39.76 850.35 39.76C857.96 39.76 863.68 41.01 867.54 43.49C871.39 45.99 873.33 50.35 873.33 56.62V63.61Z"
          fill="#fff"
        />
        <path
          d="M55.62 26.23H52.8C48.67 31.46 31.87 53.27 29.21 57.43C27.99 59.37 26.64 62.69 26.04 65.7C26.04 65.73 26.04 65.76 26.03 65.79C25.73 67.38 25.67 68.89 26 70.06C26 70.06 26.0033 70.07 26.01 70.09C26.96 75.43 31.62 79.47 37.25 79.47C43.57 79.47 48.7 74.36 48.7 68.03C48.7 67.86 48.7 67.7 48.67 67.55C48.69 67.49 48.69 67.44 48.7 67.38H51.83L51.8 75.87C51.75 87.91 42.3 89.15 37.31 90.21C37.31 90.32 37.32 95.08 37.31 95.19C41.21 95.21 67.13 95.28 71.01 95.3C71.01 95.19 71.03 90.43 71.03 90.32C66.04 89.22 56.58 87.93 56.63 75.89L56.66 67.42H59.79C59.82 67.6 59.84 67.78 59.87 67.96C60.02 69.12 60.22 70.24 60.43 71.32C60.48 71.56 60.54 71.8 60.61 72.05C60.64 72.2 60.7 72.35 60.76 72.49C61.24 73.91 62.08 75.12 63.13 76.04C65.2 78.16 68.09 79.47 71.3 79.47C77.38 79.47 82.34 74.75 82.72 68.76C82.73 68.74 82.73 68.73 82.72 68.71C83.16 65.32 81.16 60.66 79.47 57.92C77.26 54.32 59.71 31.48 55.61 26.23H55.62Z"
          fill="#fff"
        />
        <path
          d="M95.67 6H29.85C13.56 6 0.34 19.05 0.02 35.23C0.02 35.43 0 35.63 0 35.83V101.63H12.84V114.49H78.66C95.15 114.49 108.51 101.12 108.51 84.64V18.86H95.67V6ZM82.73 68.7C82.73 68.7 82.74 68.73 82.73 68.75C82.35 74.74 77.39 79.46 71.31 79.46C68.1 79.46 65.21 78.14 63.14 76.03C62.08 75.11 61.25 73.9 60.77 72.48C60.71 72.34 60.65 72.19 60.62 72.04C60.54 71.8 60.48 71.56 60.44 71.31C60.23 70.24 60.03 69.12 59.88 67.95C59.85 67.77 59.83 67.59 59.8 67.41H56.67L56.64 75.88C56.59 87.92 66.05 89.21 71.04 90.31C71.04 90.42 71.02 95.18 71.02 95.29C67.13 95.27 41.22 95.2 37.32 95.18C37.33 95.07 37.32 90.31 37.32 90.2C42.31 89.14 51.77 87.9 51.81 75.86L51.84 67.37H48.71C48.7 67.43 48.7 67.48 48.68 67.54C48.71 67.69 48.71 67.86 48.71 68.02C48.71 74.34 43.58 79.46 37.26 79.46C31.63 79.46 26.97 75.42 26.02 70.08C26.02 70.08 26.0167 70.07 26.01 70.05C25.68 68.89 25.74 67.37 26.04 65.78C26.05 65.75 26.05 65.72 26.05 65.69C26.64 62.68 27.99 59.36 29.22 57.42C31.88 53.26 48.68 31.45 52.81 26.22H55.63C59.73 31.47 77.28 54.31 79.49 57.91C81.18 60.65 83.18 65.31 82.74 68.7H82.73Z"
          fill="#1111BC"
        />
      </svg>

      <span class="shutdown-status">
        <span
          aria-hidden="true"
          class="shutdown-dot"
        />
        Plataforma inativa
      </span>

      <h1 class="shutdown-title">O site da ApostaTudo está indisponível</h1>

      <p class="shutdown-lead">
        Em cumprimento à
        <strong>Medida Provisória nº 1.394/2026</strong>, que encerra a
        exploração de apostas de quota fixa no Brasil, o site e o aplicativo da
        ApostaTudo estão fora do ar desde <strong>6 de outubro de 2026</strong>.
      </p>

      <section
        aria-labelledby="shutdown-balance-title"
        class="shutdown-card"
      >
        <span
          aria-hidden="true"
          class="shutdown-card-icon"
        >
          <svg
            fill="#fff"
            height="20"
            viewBox="0 0 24 24"
            width="20"
          >
            <path
              d="M3 6h18v12H3V6Zm2 2v8h14V8H5Zm7 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM6 9h2v2H6V9Zm10 4h2v2h-2v-2Z"
            />
          </svg>
        </span>

        <h2 id="shutdown-balance-title">E o saldo da minha conta?</h2>

        <p>
          Os valores que permaneceram na plataforma serão devolvidos pela
          instituição financeira vinculada ao seu CPF, conforme o cronograma da
          MP. Se a devolução não for possível, os recursos serão repassados à
          Caixa Econômica Federal, que fará o pagamento.
        </p>
      </section>

      <p class="shutdown-contact">
        Dúvidas? Fale com a gente em
        <a href="mailto:suporte@apostatudo.bet.br">suporte@apostatudo.bet.br</a>
      </p>

      <p class="shutdown-thanks"
        >Obrigado por ter feito parte da nossa história.</p
      >
    </main>

    <footer class="shutdown-footer">
      <span class="shutdown-age">18+</span>
      <span>BLOW MARKETPLACE LTDA · CNPJ 37.486.405/0001-91</span>
    </footer>
  </div>
</template>

<style scoped>
.shutdown {
  --bg: #020716;
  --line: rgba(140, 160, 255, 0.14);
  --text: #f2f4fa;
  --muted: #9aa3b8;
  --soft: #6b7389;
  --orange: #ff7a1a;

  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  overflow-x: hidden;
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: var(--bg);
  color: var(--text);
  font-family:
    'Plus Jakarta Sans',
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Luz de fundo. */
.shutdown::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(
      60% 45% at 50% 0%,
      rgba(43, 59, 255, 0.22),
      transparent 70%
    ),
    radial-gradient(
      40% 30% at 85% 100%,
      rgba(17, 17, 188, 0.18),
      transparent 70%
    );
}

/* Grade, apagando nas bordas. */
.shutdown::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  opacity: 0.35;
  pointer-events: none;
  background-image:
    linear-gradient(var(--line) 1px, transparent 1px),
    linear-gradient(90deg, var(--line) 1px, transparent 1px);
  background-size: 56px 56px;
  -webkit-mask-image: radial-gradient(
    70% 60% at 50% 30%,
    #000 10%,
    transparent 75%
  );
  mask-image: radial-gradient(70% 60% at 50% 30%, #000 10%, transparent 75%);
}

.shutdown-main {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: clamp(40px, 9vh, 96px) 24px 40px;
  text-align: center;
}

.shutdown-logo {
  display: block;
  width: min(260px, 68vw);
  height: auto;
  animation: shutdown-rise 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: clamp(36px, 6vh, 56px);
  padding: 8px 14px 8px 12px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: rgba(5, 12, 31, 0.7);
  color: var(--muted);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  animation: shutdown-rise 0.8s 0.08s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-dot {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--orange);
}

.shutdown-dot::after {
  content: '';
  position: absolute;
  inset: -4px;
  border: 2px solid var(--orange);
  border-radius: 50%;
  opacity: 0;
  animation: shutdown-ping 2.2s ease-out infinite;
}

.shutdown-title {
  margin-top: 20px;
  font-size: clamp(30px, 6.4vw, 48px);
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -0.025em;
  text-wrap: balance;
  animation: shutdown-rise 0.8s 0.14s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-lead {
  max-width: 52ch;
  margin-top: 18px;
  color: var(--muted);
  font-size: clamp(15px, 2.4vw, 17px);
  line-height: 1.65;
  text-wrap: pretty;
  animation: shutdown-rise 0.8s 0.2s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-lead strong {
  color: var(--text);
  font-weight: 600;
}

.shutdown-card {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 4px 14px;
  width: 100%;
  margin-top: clamp(28px, 5vh, 40px);
  padding: 22px 22px 20px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: linear-gradient(
    180deg,
    rgba(5, 12, 31, 0.92),
    rgba(5, 12, 31, 0.72)
  );
  text-align: left;
  animation: shutdown-rise 0.8s 0.26s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-card-icon {
  display: grid;
  grid-row: span 2;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(80, 100, 255, 0.35);
  border-radius: 10px;
  background: rgba(17, 17, 188, 0.35);
}

.shutdown-card h2 {
  align-self: center;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.shutdown-card p {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.6;
}

.shutdown-contact {
  margin-top: 22px;
  color: var(--soft);
  font-size: 14px;
  line-height: 1.6;
  animation: shutdown-rise 0.8s 0.32s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-contact a {
  color: var(--text);
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.3);
  text-underline-offset: 3px;
}

.shutdown-contact a:hover {
  text-decoration-color: var(--text);
}

.shutdown-thanks {
  margin-top: 36px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 500;
  animation: shutdown-rise 0.8s 0.38s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.shutdown-footer {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 20px;
  padding: 20px 24px;
  border-top: 1px solid var(--line);
  color: var(--soft);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}

.shutdown-age {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 20px;
  padding: 0 6px;
  border: 1px solid var(--soft);
  border-radius: 5px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 700;
}

@keyframes shutdown-rise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes shutdown-ping {
  0% {
    opacity: 0.7;
    transform: scale(0.6);
  }

  80%,
  100% {
    opacity: 0;
    transform: scale(1.8);
  }
}

@media (prefers-reduced-motion: reduce) {
  .shutdown,
  .shutdown *,
  .shutdown *::after {
    animation: none !important;
  }
}

@media (max-width: 420px) {
  .shutdown-card {
    grid-template-columns: 1fr;
  }

  .shutdown-card-icon {
    grid-row: auto;
    margin-bottom: 6px;
  }
}
</style>
